// src/components/ui/Select.tsx
import React from "react";

type Option = { value: string; label: string };

type Props = React.SelectHTMLAttributes<HTMLSelectElement> & {
  label?: string;
  error?: string;
  options: Option[];
  placeholder?: string;
};

export default function Select({
  label,
  error,
  options,
  placeholder,
  className,
  ...props
}: Props) {
  return (
    <label className="block">
      {label ? (
        <span className="mb-1 block text-sm font-medium text-slate-700">
          {label}
        </span>
      ) : null}
      <select
        {...props}
        className={`w-full appearance-none rounded-lg border px-3 py-3 text-sm outline-none transition focus:border-slate-400 ${
          error ? "border-red-400 bg-red-50" : "border-slate-300 bg-white"
        } ${className ?? ""}`}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error ? <span className="mt-1 block text-xs text-red-600">{error}</span> : null}
    </label>
  );
}
